"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reingestDeadLetter = exports.listDeadLetters = void 0;
const ApiClient_1 = require("../ApiClient");
const listDeadLetters = (filters) => {
    const params = new URLSearchParams();
    if (filters.reason)
        params.set('reason', filters.reason);
    if (filters.reingested)
        params.set('reingested', filters.reingested);
    if (filters.page)
        params.set('page', String(filters.page));
    const query = params.toString();
    return ApiClient_1.apiClient.get(`/api/dead-letters${query ? `?${query}` : ''}`);
};
exports.listDeadLetters = listDeadLetters;
const reingestDeadLetter = (id) => ApiClient_1.apiClient.post(`/api/dead-letters/${encodeURIComponent(id)}/reingest`);
exports.reingestDeadLetter = reingestDeadLetter;
